export default __webpack_public_path__ + "static/media/search.470fde85.svg";